import { render, staticRenderFns } from "./Prefeituras.vue?vue&type=template&id=e6eb2fc6&scoped=true&"
import script from "./Prefeituras.vue?vue&type=script&lang=js&"
export * from "./Prefeituras.vue?vue&type=script&lang=js&"
import style0 from "./Prefeituras.vue?vue&type=style&index=0&id=e6eb2fc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6eb2fc6",
  null
  
)

export default component.exports